import axios from "axios";

/**
 * Define the base url of the monkey server so that the link of the server can be easliy changed.
 */
export default axios.create({
  baseURL: "https://monkeymonkeymonkey.herokuapp.com/"
});